import { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { aoiService } from "../Services/aoiService";
import EditIcon from '../Assets/img/icon-edit-grey.svg';
import { AOIContext } from "../Contexts/AOIContext";

const UploadAOIModal = (props) => {
    const [aoiName, setAoiName] = useState("");
    const [file, setFile] = useState(null);
    const [createdAOIs, setCreatedAOIs] = useState([]);
    const {allAOIs, editAOI, reloadAOIs, selectedOrgId, showAlert} = useContext(AOIContext);

    useEffect(()=>{
        let recentlyCreatedAOIs = allAOIs?.filter(aoi => createdAOIs.findIndex(a => a.aoiId == aoi.aoiId) >= 0);
        recentlyCreatedAOIs = recentlyCreatedAOIs.sort((a, b) => Number(a.name) - Number(b.name));
        setCreatedAOIs(recentlyCreatedAOIs);
    }, [allAOIs]);

    const handleFileChange = (event) => {
        if (event.target.files[0]) {
            setFile(event.target.files[0]);
        } else {
            setFile(null);
        }
    }

    const onCreateAOIByFileUpload = () => {
        if (file == null) 
            return;

        aoiService.aoiFileUpload(selectedOrgId, file, aoiName)
        .then(result => {
            if (result?.length > 0) {
                setCreatedAOIs(result.sort((a, b) => Number(a.name) - Number(b.name)));
                showAlert("AOI(s) Imported Successfully","success");
                reloadAOIs();
                setFile(null);
                document.getElementsByClassName("upload-input")[0].value = "";
            }
        })
    }

    const editNewAOI = (aoiId) => {
        if (!!aoiId) {
            editAOI(aoiId);
        }
    }

    return (
        <Modal
            show={() => props.setShowAOIUploadModal(true)}
            onHide={() => props.setShowAOIUploadModal(false)}
            backdrop="static"
            keyboard={false}
            dialogClassName="modal-600 upload-aoi-modal-dialog"
            className="upload-aoi-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title>Upload AOI GeoJson/KML/KMZ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="aoi-upload-section form-group">
                    <label className="form-label" htmlFor="aoiName">AOI Name &nbsp; </label>
                    <input name="aoiName" type="text" className="upload-input" onChange={(e) => setAoiName(e.target.value)} value={aoiName} placeholder="AOI Name" />

                    <label  className="form-label" htmlFor="aoiFileUpload">Choose a file (GeoJSON, KML, or KMZ) : &nbsp;</label>
                    <input type="file" className="upload-input" onChange={handleFileChange} accept=".geojson,.kml,.kmz" />

                    <button className="btn btn-primary aoi-upload-create" onClick={onCreateAOIByFileUpload} disabled={!file}>Create AOI(s)</button>
                </div>
                <div className="aoi-upload-created-aois-list">
                    {
                        createdAOIs?.length > 0 &&
                        <table>
                            <tbody>
                                <tr>
                                    <th>AOI Name</th>
                                    <th>Bounds</th>
                                </tr>
                                {
                                    createdAOIs.map(aoi => 
                                        <tr>
                                            <td className="aoi-name">{aoi.name}</td>
                                            <td className="aoi-bounds">{`[${aoi.minx}, ${aoi.miny}, ${aoi.maxx}, ${aoi.maxy}]`}</td>
                                            <td><a onClick={()=>editNewAOI(aoi.aoiId)}><img src={EditIcon} className="edit-aoi-icon"/></a></td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    }
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default UploadAOIModal;